<template>
    <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
            <v-btn
                v-on="{ ...tooltip }"
                small
                :fab="params.fab ? params.fab : false"
                :icon="params.fab ? false : true"
                :color="params.button_color ? params.button_color : ''"
                :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : 'mx-0'"
                @click.native.stop="openDialog()">
                <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ params.icon }}</v-icon>

                <v-dialog v-model="show" max-width="900" persistent class="round-card" :fullscreen="fullScreen || $vuetify.breakpoint.smAndDown" scrollable>
                    <v-card class="background-2 round-card">
                        <v-card-title class="pa-3">
                            <p class="pl-2 pl-xl-3">{{ titleDialog }}</p>
                            <v-spacer></v-spacer>
					        <v-btn icon @click.native.stop="fullScreen = !fullScreen"><v-icon>fullscreen</v-icon></v-btn>
                        </v-card-title>            
                        <v-divider></v-divider>
                        <v-card-text class="px-1 pb-1">

                            <v-container v-if="show" fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                                <v-row>
                                    <v-col class="col-6">
                                        <v-btn :disabled="model.file" color="info" @click.native.stop="generateConfig()">Genera configurazione</v-btn>
                                    </v-col>
                                    <v-col class="col-6">
                                        <v-btn :disabled="!model.file" color="info"  @click.native.stop="$eventBusUtility.openFile($store, '/assets-download-config/' + model.id, 'Y' + model.id + '.tar')">Download configurazione</v-btn>
                                    </v-col>
                                    <v-col class="col-12" v-if="result.code">
                                        <v-alert outlined :type="alertType" prominent border="left" class="text-capitalize">
                                            {{ $trans(result.message) }}
                                        </v-alert>
                                    </v-col>
                                </v-row>
                            </v-container>

                        </v-card-text>

                        <v-divider></v-divider>
                        
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="info" @click.native.stop="closeDialog()">Annulla
                            </v-btn>
                            <v-btn text color="primary" @click.native.stop="createModel()" :loading="loading">{{params.create ? 'Salva' : 'Modifica'}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-btn>
        </template>
        <span>{{ titleDialog }}</span>
    </v-tooltip>
</template>

<script>

    export default {
        name: 'generate-configuration-button',
        components: {
        },
        props: {
            model: Object,
            params: Object,
        },

        data() {
            return {
                show: false,
                loading: false,
                fullScreen: false,
                confirmExit: false,
                result: {}
            }
        },

        computed: {
            titleDialog() {
                return this.params.tooltip                
            },

            alertType() {
                switch(this.result.code) {
                    case 200:
                        return 'success';
                    case 402:
                        return 'warning'
                    case 400:
                        return 'error';
                    case 500:
                        return 'error'
                    default:
                        return ''
                }
            }
        },

        methods: {

            closeDialog() {
                this.show = false
                this.result = {}
            },

            openDialog() {
                this.show = true
            },
                
            generateConfig() {

                this.axios.get('assets-generate-config/' + this.model.id).then(response => {
                    // get body data
                    this.result = response.data
			        this.$eventBusUtility.$emit('refreshAsset')

                }, response => {

                })
            },

            //model is trouble
            createModel() {
                this.confirmExit = false

            },
        
        },
    }
</script>